<template>
<div class="chapter">
<div class="inner_page">
<section class="SOM" epub:type="toc" role="doc-toc">
<h1 class="SOM_titre" epub:type="title">Contents</h1>
<div class="SOM_pre"><a href="#/pre1"><span>Foreword</span> BY DAN KIMBALL</a></div>
<div class="SOM_pre"><a href="#/pre2"><span>Introduction</span> | Digital Smoke, Analog Air, and Fruit</a></div>
<div class="SOM_part"><a href="#/p1">Part I: Cultivating Contentment</a></div>
<div class="SOM_chap"><a href="#/p1chap2"><span>1</span> | Love Instead of Self-Centric Despair</a></div>
<div class="SOM_chap"><span href="#/p1chap3" title="Link target outside of Sample"><span>2</span> | Joy Instead of Comparison</span></div>
<div class="SOM_chap"><span href="#/p1chap4" title="Link target outside of Sample"><span>3</span> | Peace Instead of Contempt</span></div>
<div class="SOM_part"><span href="#/p2" title="Link target outside of Sample">Part II: Cultivating Resilience</span></div>
<div class="SOM_chap"><span href="#/p2chap2" title="Link target outside of Sample"><span>4</span> | Patience Instead of Impatience</span></div>
<div class="SOM_chap"><span href="#/p2chap3" title="Link target outside of Sample"><span>5</span> | Kindness and Goodness Instead of Hostility</span></div>
<div class="SOM_part"><span href="#/p3" title="Link target outside of Sample">Part III: Cultivating Wisdom</span></div>
<div class="SOM_chap"><span href="#/p3chap2" title="Link target outside of Sample"><span>6</span> | Faithfulness Instead of Forgetfulness</span></div>
<div class="SOM_chap"><span href="#/p3chap3" title="Link target outside of Sample"><span>7</span> | Gentleness Instead of Outrage</span></div>
<div class="SOM_chap"><span href="#/p3chap4" title="Link target outside of Sample"><span>8</span> | Self-Control Instead of Reckless Indulgence</span></div>
<div class="SOM_appen"><span href="#/appen1" title="Link target outside of Sample">Conclusion | <span>Gardening in the Nicu</span></span></div>
<div class="SOM_appen"><span href="#/appen2" title="Link target outside of Sample">Acknowledgments</span></div>
<div class="SOM_appen"><span href="#/appen3" title="Link target outside of Sample">Questions for Reflection and Discussion</span></div>
<div class="SOM_appen"><span href="#/appen4" title="Link target outside of Sample">Notes</span></div>
<div class="SOM_appen"><span href="#/appen5" title="Link target outside of Sample">The ReGeneration Project</span></div>
<div class="SOM_appen"><span href="#/appen6" title="Link target outside of Sample">Praise for <i>Analog Christian</i></span></div>
<div class="SOM_appen"><span href="#/appen7" title="Link target outside of Sample">About the Author</span></div>
<div class="SOM_appen"><span href="#/appen8" title="Link target outside of Sample">Also by Jay Y. Kim</span></div>
<div class="SOM_pdf"><span href="#/fin_acheve" title="Link target outside of Sample">More Titles from InterVarsity Press</span></div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// sommaire.vue?a445dc18